import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TablePagination from "@mui/material/TablePagination";
import IconButton from "@mui/material/IconButton";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CircularProgress from "@mui/material/CircularProgress";
import {
  DeleteIcon,
  DownloadIcon,
  PswdvisibleIcon,
} from "../../../assets/icons-components/Icons";
import CustomTooltip from "../../../components/CustomTooltip/CustomTooltip";
import TableStatusRow from "../../../components/TableStatusRow/TableStatusRow";

const SESSION_TABLE_COLUMN_COUNT = 12;

const SessionTable = ({
  rows,
  page,
  rowsPerPage,
  totalRows,
  processingSessionId,
  noT,
  formatDateOnly,
  formatSecondsToHMS,
  onView,
  onDownload,
  onDelete,
  onChangePage,
  onChangeRowsPerPage,
  isLoading,
  fetchError,
  onRetry,
}) => {
  return (
    <div className="table-container">
      <TableContainer component={Paper}>
        <Table aria-label="collapsible table">
          <TableHead>
            <TableRow>
              <TableCell>SL NO</TableCell>
              <TableCell>Start Time (UTC)</TableCell>
              <TableCell>End Time (UTC)</TableCell>
              <TableCell>Created Date (UTC)</TableCell>
              <TableCell>Updated Date (UTC)</TableCell>
              <TableCell>Length</TableCell>
              <TableCell>Sampling Rate (Hz)</TableCell>
              <TableCell>Number of Samples</TableCell>
              <TableCell>Aquisition Mode</TableCell>
              <TableCell>Action</TableCell>
              <TableCell>Download Count</TableCell>
              <TableCell>Download Date</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows?.length === 0 ? (
              <TableStatusRow
                colSpan={SESSION_TABLE_COLUMN_COUNT}
                loading={isLoading}
                error={fetchError}
                onRetry={onRetry}
                emptyMessage="No sessions found"
              />
            ) : (
              rows.map((row, index) => (
              <TableRow
                key={row.referenceId}
                sx={{
                  "&:hover": {
                    backgroundColor: "#f5f5f5",
                  },
                }}
              >
                <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                <TableCell>{noT(row?.startTime) || "-"}</TableCell>
                <TableCell>{noT(row?.endTime) || "-"}</TableCell>
                <TableCell>{noT(row.createdDate) || "-"}</TableCell>
                <TableCell>{noT(row.updatedDate) || "-"}</TableCell>
                <TableCell>{formatSecondsToHMS(row.duration)}</TableCell>
                <TableCell>{row.samplingRate ?? "-"}</TableCell>
                <TableCell>{row.numberOfSamples ?? "-"}</TableCell>
                <TableCell>{row.isOnline ? "Online" : "Offline"}</TableCell>
                <TableCell>
                  <div className="action" style={{ display: "flex", gap: "15px" }}>
                    <CustomTooltip title="View">
                      <IconButton
                        aria-label="view"
                        onClick={() => onView(row)}
                      >
                        <PswdvisibleIcon />
                      </IconButton>
                    </CustomTooltip>

                    <CustomTooltip title="Download">
                      <span>
                        <IconButton
                          aria-label="download"
                          disabled={processingSessionId === row.id}
                          onClick={() => onDownload(row)}
                        >
                          {processingSessionId === row.id ? (
                            <CircularProgress size="20px" />
                          ) : (
                            <DownloadIcon />
                          )}
                        </IconButton>
                      </span>
                    </CustomTooltip>

                    <CustomTooltip
                      title={`Reference ID: ${row.referenceId || "N/A"}`}
                    >
                      <IconButton aria-label="info">
                        <InfoOutlinedIcon />
                      </IconButton>
                    </CustomTooltip>

                    <CustomTooltip title="Delete">
                      <IconButton
                        aria-label="delete"
                        onClick={() => onDelete(row.referenceId)}
                      >
                        <DeleteIcon />
                      </IconButton>
                    </CustomTooltip>
                  </div>
                </TableCell>
                <TableCell>
                  {typeof row.csvDownloadCount !== "undefined" &&
                  typeof row.maxCsvDownloadCount !== "undefined" ? (
                    <span
                      style={{
                        alignSelf: "center",
                        fontSize: "13px",
                        color: "#666",
                        minWidth: 40,
                        textAlign: "center",
                      }}
                    >
                      {row.csvDownloadCount}/{row.maxCsvDownloadCount}
                    </span>
                  ) : (
                    "-"
                  )}
                </TableCell>
                <TableCell>
                  {row.csvDownloadedDate
                    ? `${formatDateOnly(row.csvDownloadedDate)}`
                    : "-"}
                </TableCell>
              </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <TablePagination
        rowsPerPageOptions={[50, 100]}
        component="div"
        count={totalRows}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={onChangePage}
        onRowsPerPageChange={onChangeRowsPerPage}
      />
    </div>
  );
};

export default SessionTable;
